import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function manageAssetReducer(state = initialState.manageAsset, action) {
	//avoiding state mutation, while updating nested states.
	switch (action.type) {
		case types.FETCH_MANAGEASSET_DATA:
			const asset = action.data;
			return {
				...state,
				id: asset.id,
				name: asset.name,
				archived: asset.archived,
				barcode: asset.barcode,
				jiraTask: asset.jiraTask,
				createdAt: asset.createdAt,
				updatedAt: asset.updatedAt,
				tags: asset.tags ?? [],
				product: asset.product ?? {},
				sourceFiles: asset.sourceFiles ?? [],
				artifacts: asset.artifacts ?? [],
				alignment: asset?.alignment ?? {},
			};
		case types.MANAGE_ASSET_DELETE_TAG:
			return {
				...state,
				tags: [...state.tags.filter((tag) => tag !== action.data)],
			};
		case types.MANAGE_ASSET_ADD_TAG:
			return Object.assign({}, state, {
				tags: [...state.tags, action.data],
			});
		case types.MANAGE_ASSET_DELETE_ALL_TAGS:
			//delete all tags for this asset
			return {
				...state,
				tags: [],
			};
		case types.MANAGE_ASSET_LINK_PRODUCT:
			// linking a product to asset
			return {
				...state,
				product: { ...action.data },
			};
		case types.MANAGE_ASSET_ADD_FILES:
			// when adding new source file to asset state. also add artifacts of the source file to artifacts list.
			return {
				...state,
				sourceFiles: [...state.sourceFiles, ...action.data],
				artifacts: [...state.artifacts, ...action.data[0].artifacts],
			};
		case types.MANAGE_ASSET_REMOVE_ALL_FILES:
			// remove all source files from manage asset.
			return {
				...state,
				files: [],
			};
		case types.MANAGE_ASSET_CHANGE_ARTIFACT_STATUS:
			// change artifact status.
			const { artifact, status } = action.data;
			const updatedArtifacts = state.artifacts.map((a) => {
				if (a.id === artifact.id) {
					return {
						...a,
						status: status,
					};
				}
				return a;
			});
			return {
				...state,
				artifacts: updatedArtifacts,
			};
		case types.MANAGE_ASSET_REMOVE_FILE:
			// remove file
			return {
				...state,
				files: [...state.files.filter((file) => file.path !== action.data.path)],
			};
		case types.MANAGE_ASSET_SET_PRIMARY_FILE: {
			// set 'isPrimary' for existing primary file to false. and make new file as primary
			// at a given time only one sourceFile can be primary.
			const primarySourceFile = action.data;
			const sourceFiles = state.sourceFiles.map((file) => {
				if (file.id === primarySourceFile.id) {
					return {
						...file,
						isPrimary: true,
					};
				}
				return {
					...file,
					isPrimary: false,
				};
			});
			return {
				...state,
				sourceFiles: sourceFiles,
			};
		}
		case types.MANAGE_ASSET_UPDATE_JIRA_TICKET: {
			return {
				...state,
				jiraTask: action.data,
			};
		}
		case types.MANAGE_ASSET_REBUILD_SOURCE_FILE: {
			return {
				...state,
				artifacts: [...state.artifacts, ...action.data.artifacts],
			};
		}
		case types.MANAGE_ASSET_REBUILD_ARTIFACT_FILE: {
			const updatedArtifacts = state.artifacts.map((a) => {
				if (a.id === action.data.id) {
					return { ...action.data };
				}
				return a;
			});
			return {
				...state,
				artifacts: updatedArtifacts,
			};
		}
		default:
			return state;
	}
}
